export default __webpack_public_path__ + "static/media/shakuni-blck.51086f6b.jpeg";